import { render, staticRenderFns } from "./home-metrics.vue?vue&type=template&id=8848e370&scoped=true"
var script = {}
import style0 from "./home-metrics.vue?vue&type=style&index=0&id=8848e370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8848e370",
  null
  
)

export default component.exports